export default "__VITE_ASSET__D3Pv4jQb__"